module.exports = __webpack_public_path__ + "static/media/dislikeButton.a96d0221.png";